<template>
    <div class="credit-balance">
        <div class="box" @click="goToCreditBreakdown()" :class="{'pointer': isEscort}">
            <div>
                <img :src="regionRelativeUrl('/images/euro_icon.png')" height="24" width="41">
            </div>
            <div>
                <span e2e-id="user-credits">
                    <span class="balance-text">{{ translate.account.balance }}: </span>
                    {{ formatCredits(credits) + ' ' + translate.account.creditsShort }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import userMixin from "@/components/mixins/userMixin";
import {mapState} from 'vuex';
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";

function goToCreditBreakdown() {
    if (this.isEscort) {
        this.$router.push({name: 'profile.credit_breakdown'});
    }
}

function formatCredits(credits) {
    return Number(credits || 0).toFixed(2);
}

export default {
    methods: {
        regionRelativeUrl,
        goToCreditBreakdown,
        formatCredits
    },
    computed: {
        ...mapState(['translate', 'currentUser']),
        credits() {
            // Get credits from currentUser which is updated by AiConversationMessagesComponent
            let userCredits = _.get(this.currentUser, 'credits', 0);

            if (typeof isManagerLoggedIn !== 'undefined' && isManagerLoggedIn) {
                userCredits = context.managerData.credits;
            }

            return userCredits;
        }
    },
    mixins: [userMixin]
}
</script>
